define('evicommon/spf/spf.helper',['require','exports','module','backbone','underscore','../bind/bind.helper','./paginate.adapter','./filter.adapter','./sort.adapter','./model/paginate','./model/filter','./model/sort'],function(require, exports, module){
  var Backbone        = require('backbone');
  var _               = require('underscore');
  var BindHelper      = require('../bind/bind.helper');
  var PaginateAdapter = require('./paginate.adapter');
  var FilterAdapter   = require('./filter.adapter');
  var SortAdapter     = require('./sort.adapter');
  var Paginate        = require('./model/paginate');
  var Filter          = require('./model/filter');
  var Sort            = require('./model/sort');

  function SPFHelper(collection, options) {
    options = _.extend({}, options);

    if (collection.spfHelper) {
      // we never want more than one SPFHelper on a collection
      throw new Error("An SPFHelper already exists on this collection");
    }

    collection.spfHelper = this;
    this.collection = collection;
    this.paginate = new Paginate(options.paginateDefaults || {});
    this.filter = new Filter(options.filterDefaults || {});
    this.sort = new Sort(options.sortDefaults || {});

    var autoFetch = options.autoFetch;

    options.autoFetch = false;

    collection
        .addAdapter(this.paginateAdapter = new PaginateAdapter(this.paginate, options.paginate))
        .addAdapter(this.filterAdapter = new FilterAdapter(this.filter, options.filter))
        .addAdapter(this.sortAdapter = new SortAdapter(this.sort, options.sort))

    if (autoFetch) {
      this.setupAutoFetch();
    }
  };

  SPFHelper.extend = Backbone.View.extend;

  _.extend(SPFHelper.prototype, {

    setupAutoFetch: function() {
      if (this._didSetupAutoFetch) { return this; }
      this._didSetupAutoFetch = true;

      var fetch = _.debounce(_.bind(this.fetch, this, null), 1),
          collection = this.collection,
          self  = this;

      collection.on('request', function(collection, xhr, options) {

        // Handle with cancelling previous events
        if (self._autoFetchXhr) {
          self._autoFetchXhr.abort();
          self._autoFetchXhr = null;
        }
        xhr.promise().tap(function() {
          self._autoFetchXhr = null;
        });
        self._autoFetchXhr = xhr;

      }, this);

      collection.once('request', function() {
        // reset to page one when we change the size, we don't know what page we
        // should be on in that case.
        this.collection.listenTo(this.paginate, 'change:page change:size', function() {
          fetch();
        });
        this.paginate.on('change:size', this.resetPage, this);
        this.collection.listenTo(this.filter, 'change', function() {
          self.resetPage();
          fetch();
        });
        this.collection.listenTo(this.sort, 'change', function() {
          self.resetPage();
          fetch();
        });
      }, this);
      return this;
    },

    fetch: function() {
      return this.collection.fetch.apply(this.collection, arguments);
    },

    setSortField: function(field) {
      this.sort.set(Sort.SORT_FIELD, field);
      return this;
    },

    setSortDirection: function(direction) {
      this.sort.set(Sort.SORT_DIRECTION, direction);
      return this;
    },

    setPaginateSize: function(size) {
      this.paginate.set(Paginate.SIZE, size);
      return this;
    },

    setPaginatePage: function(page) {
      this.paginate.set(Paginate.PAGE, page);
      return this;
    },

    setFilterParams: function(params) {
      this.filter.set(params);
      return this;
    },

    hasNextPage: function() {
      var currentPage = this.paginate.get(Paginate.PAGE),
          totalPages  = this.paginate.get(Paginate.TOTAL_PAGES);

      if (_.isNumber(totalPages) && currentPage === totalPages) {
        return false;
      }
      return true;
    },

    incrementPage: function() {
      var currentPage = this.paginate.get(Paginate.PAGE);

      if (this.hasNextPage()) {
        this.setPaginatePage(++currentPage);
      }
      return this;
    },

    decrementPage: function() {
      var currentPage = this.paginate.get(Paginate.PAGE);
      if (currentPage > 1) {
        this.setPaginatePage(--currentPage);
      }
      return this;
    },

    resetPage: function() {
      this.paginate.set(Paginate.PAGE, 1);
      return this;
    },

    pageSize: function() {
      return this.paginate.get(Paginate.SIZE);
    },

    totalItems: function() {
      return this.paginate.get(Paginate.TOTAL_ITEMS);
    },

    totalPages: function() {
      return this.paginate.get(Paginate.TOTAL_PAGES);
    },

    setupState: function(state, filterKeys) {
      this.importState(state, filterKeys);
      return this.bindState(state, filterKeys);
    },

    importState: function(state, filterKeys) {
      var sortFields     = [Sort.SORT_FIELD, Sort.SORT_DIRECTION],
          paginateFields = [Paginate.PAGE, Paginate.SIZE];

      function copyFields(src, dest, fields) {
        _.each(fields, function(key) {
          var value;
          if (src.has(key)) {
            var value = src.get(key);
            if (String(value).length > 0) {
              if (key == Paginate.PAGE || key == Paginate.SIZE) {
                value = Number(value) || 0;
              }
              dest.set(key, value);
            }
          }
        });
      };

      // copy properties from state to appropriate models
      copyFields(state, this.paginate, paginateFields);
      copyFields(state, this.sort, sortFields);
      copyFields(state, this.filter, filterKeys);

      return this;
    },

    bindState: function(state, filterKeys) {
      // we exclude role because that is unique to a page

      var paginateBindHelper = new BindHelper(this.paginate, state)
          .bind(Paginate.PAGE)
          .bind(Paginate.SIZE)
          .transfer()

      var sortBindHelper = new BindHelper(this.sort, state)
          .bind(Sort.SORT_FIELD)
          .bind(Sort.SORT_DIRECTION)
          .transfer()

      var filterBindHelper = new BindHelper(this.filter, state)
          .bindAll(filterKeys)
          .transfer()

      return {
        unbind: function() {
          paginateBindHelper.stopListening().off();
          sortBindHelper.stopListening().off();
          filterBindHelper.stopListening().off();
        }
      }
    }

  });

  module.exports = SPFHelper;
});
